import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import Step1 from './Step1.react';
import Step2 from './Step2.react';
import Step3 from './Step3.react';
var Step = function Step() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-step__body"
  }, /*#__PURE__*/React.createElement(Step1, null), /*#__PURE__*/React.createElement(Step2, null), /*#__PURE__*/React.createElement(Step3, null)));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Step);